import React from "react";
import { Container } from "react-bootstrap";
import Banner from "../components/ContactUs/Banner";
import Features from "../components/ContactUs/Features";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5rem",
      }}
    >
      <Banner
        header="Terms and Conditions"
        text="Transparency & trust with Datacom. Understand our policies and order your favorite mobile phone worry-free."
      />
      <Container>
        <section className="mb-4">
          <h3>Welcome to Datacom</h3>
          <p>
            Welcome to Datacom, your trusted online store for mobile phones. We
            are committed to providing our customers with the best possible
            shopping experience, and these terms and conditions are designed to
            ensure that everyone has a fair and enjoyable time on our site. By
            using Datacom, you agree to be bound by these terms and conditions.
            If you do not agree to these terms and conditions, please do not use
            our site.
          </p>
        </section>

        <section className="mb-4">
          <h3>Account Creation</h3>
          <p>
            To create an account on Datacom, you will need to provide your name,
            email address, and contact information. You will also need to create
            a password. You are responsible for keeping your account information
            confidential and secure. You agree to notify us immediately if you
            become aware of any unauthorized use of your account or any other
            breach of security.
          </p>
        </section>

        <section className="mb-4">
          <h3>Use of the Site and Services</h3>
          <p>
            You agree to use the Site and Services in accordance with these
            Terms and all applicable laws and regulations. You may not use the
            Site or Services for any purpose that is unlawful, illegal, or
            prohibited by these Terms.
          </p>
          <ul>
            <li>
              Violate any laws or regulations in connection with your use of the
              Site or Services.
            </li>
            <li>Infringe the intellectual property rights of others.</li>
            <li>
              Transmit any viruses, malware, or other harmful code through the
              Site or Services.
            </li>
            <li>
              Use the Site or Services to spam, solicit, or otherwise harass
              others.
            </li>
            <li>
              Use the Site or Services for any commercial purpose without the
              express written consent of Datacom.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3>Product Availability and Pricing</h3>
          <p>
            Datacom makes every effort to ensure that all mobile phones listed
            on our site are available and accurately priced. However, there may
            be occasions when a product is unavailable. In such cases, we will
            contact you to offer a refund (if the payment has already been made)
            or an alternative product. Furthermore, prices may be updated at any
            moment in accordance with market fluctuations.
          </p>
        </section>

        <section className="mb-4">
          <h3>Orders and Payments</h3>
          <p>
            Once you have placed an order on Datacom, you will receive a
            confirmation call & email. Your order will then be processed and
            shipped. For more information, visit the Refund & Shipping page. We
            accept various payment methods, including direct bank transfers,
            credit and debit cards, and cash on delivery.
          </p>
        </section>

        <section className="mb-4">
          <h3>Shipping and Delivery</h3>
          <p>
            We ship orders all across the USA. Most orders are delivered within
            3-5 business days, depending on your location, weather conditions,
            and other unforeseen circumstances.
          </p>
        </section>

        <section className="mb-4">
          <h3>Returns and Refunds</h3>
          <p>
            We offer a 14-day return policy on used mobile phones and a brand
            warranty for new mobile phones. If you are not satisfied with your
            purchase, you may return it for a full refund. However, terms &
            conditions apply. Please refer to the Return Policy and Refund &
            Shipping pages for detailed conditions. Instructions for returns
            will be provided after your refund is approved.
          </p>
        </section>

        <section className="mb-4">
          <h3>Order Cancellation Without Prior Notification</h3>
          <p>
            Datacom reserves the right to cancel orders that do not align with
            our policy. Orders may be canceled without prior notification for
            reasons such as:
          </p>
          <ul>
            <li>
              Identifying the customer as a vendor/shopkeeper running their own
              business.
            </li>
            <li>Multiple orders from the same customer.</li>
            <li>Product unavailability.</li>
            <li>Suspicious activity.</li>
            <li>Incomplete or incorrect delivery address.</li>
            <li>Payment failures or rejected transactions.</li>
            <li>Unresponsive customers for over 3 days.</li>
            <li>Price fluctuations.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h3>Warranty</h3>
          <p>
            All new mobile phones sold on Datacom are covered by a
            manufacturer's warranty. The length of the warranty varies depending
            on the product. To file a warranty claim, please contact the
            manufacturer directly. For more information, visit the 12 Months
            Warranty page.
          </p>
        </section>

        <section className="mb-4">
          <h3>Intellectual Property</h3>
          <p>
            All content on Datacom, including text, images, and logos, is
            protected by copyright and other intellectual property laws. You may
            not copy, reproduce, or distribute any content from our site without
            our express permission.
          </p>
        </section>

        <section className="mb-4">
          <h3>Limitation of Liability</h3>
          <p>
            Datacom is not liable for any damages, including direct, indirect,
            incidental, special, or consequential damages, arising from or in
            connection with your use of our site or the mobile phones purchased
            from our site.
          </p>
        </section>

        <section className="mb-4">
          <h3>Governing Law</h3>
          <p>
            These terms and conditions are governed by and construed in
            accordance with the laws of Pakistan.
          </p>
        </section>

        <section className="mb-4">
          <h3>Dispute Resolution</h3>
          <p>
            In case of any dispute, arbitration shall take place in Lahore, and
            courts in Lahore shall have jurisdiction over any related matters.
          </p>
        </section>

        <section className="mb-4">
          <h3>Contact Us</h3>
          <p>
            If you have any questions about these terms and conditions, please
            contact us at:
          </p>
          <ul>
            <li>Email: support@datacomco.com</li>
            <li>Phone: (929) 346-1108</li>
            <li>Live chat feature on the site</li>
          </ul>
        </section>

        <section className="mb-4">
          <h3>Additional Terms and Conditions</h3>
          <ul>
            <li>You agree to use Datacom only for lawful purposes.</li>
            <li>
              You agree not to post or transmit any defamatory, obscene,
              threatening, or otherwise illegal content on our site.
            </li>
            <li>
              You agree to indemnify Datacom for any losses or damages incurred
              as a result of your violation of these terms and conditions.
            </li>
            <li>
              We reserve the right to modify these terms and conditions at any
              time without notice. Continued use of Datacom constitutes
              acceptance of any modifications.
            </li>
          </ul>
        </section>

        <p className="text-center mt-5">Thank you for shopping at Datacom.</p>
      </Container>
      <Features />
    </div>
  );
};

export default TermsAndConditions;
